var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tokuSho"},[_c('button',{on:{"click":function($event){return _vm.moveToScta()}}},[_c('span',[_vm._v(_vm._s(_vm.$t('pages.scta')))]),_c('fa-icon',{attrs:{"icon":['fal', 'external-link-alt']}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }